<template>
  <div class="colorPicker">
    <div class="colorPicker-heading">
      <p class="colorPicker-heading__title">
        Color Picker
      </p>
      <div>
        <button
          class="colorPicker-heading__resetBtn btn btn--primary btn--ghost"
          @click="resetVaribles"
        >
          Reset
        </button>
        <button
          class="colorPicker-heading__exportBtn btn btn--primary"
          @click="exportVariables"
        >
          Export
        </button>
      </div>
    </div>
    <details class="colorPicker-main">
      <summary class="colorPicker-main__title">
        Main Colors
      </summary>
      <ul class="colorPicker-main-list">
        <li
          v-for="color in mainColors"
          :key="color.key"
          class="colorPicker-main-list__item"
        >
          <p>{{ color.key }}</p>
          <input
            type="color"
            :value="color.value"
            @change="handleMainColorChange(color.key, $event)"
          >
        </li>
      </ul>
    </details>
    <details class="colorPicker-components">
      <summary class="colorPicker-components__title">
        Components Colors
      </summary>
      <ul class="colorPicker-components-list">
        <li
          v-for="color in componentsColors"
          :key="color.key"
          class="colorPicker-components-list-item"
        >
          <p>{{ color.key }}</p>
          <div class="colorPicker-components-list-item-container">
            <select @change="handleComponentColorChange(color.key, $event)">
              <option
                v-for="option in componentsOptions"
                :key="option"
                :value="option"
                :selected="option == removeVarFromString(color.value)"
              >
                {{ option }}
              </option>
            </select>
            <div
              class="colorPicker-components-list-item-container__color"
              :style="{ background: getComponentsHex(color.value) }"
            />
          </div>
        </li>
      </ul>
    </details>
  </div>
</template>

<script>
  import mainColors from './main-colors.json';
  import componentsColors from './components-colors.json';
  export default {
    name: 'ColorPicker',
    data() {
      return {
        mainColors: mainColors,
        componentsColors: componentsColors,
        componentsOptions: mainColors.map(color => color.key),
      };
    },
    mounted() {
      this.loadFromLocalStorage();
    },
    methods: {
      handleMainColorChange(key, event) {
        const value = event.target.value;
        this.updateColor(key, value);
        this.storeInLocalStorage(key, value);
      },

      handleComponentColorChange(key, event) {
        const value = `var(${event.target.value})`;
        this.updateColor(key, value, false);
        this.storeInLocalStorage(key, value, false);
      },

      storeInLocalStorage(key, value, isMain = true) {
        if (isMain) {
          let mainColors = JSON.parse(localStorage.getItem('mainColors')) || [];
          mainColors = { ...mainColors, [key]: value };
          localStorage.setItem('mainColors', JSON.stringify(mainColors));
          return;
        }

        let componentsColors = JSON.parse(localStorage.getItem('componentsColors')) || [];
        componentsColors = { ...componentsColors, [key]: value };
        localStorage.setItem('componentsColors', JSON.stringify(componentsColors));
      },

      loadFromLocalStorage() {
        const mainColors = JSON.parse(localStorage.getItem('mainColors'));
        if (mainColors) {
          Object.keys(mainColors).forEach(key => {
            this.updateColor(key, mainColors[key]);
          });
        }

        const componentsColors = JSON.parse(localStorage.getItem('componentsColors'));
        if (componentsColors) {
          Object.keys(componentsColors).forEach(key => {
            this.updateColor(key, componentsColors[key], false);
          });
        }
      },

      updateColor(key, value, isMain = true) {
        document.documentElement.style.setProperty(key, value);
        if (isMain) {
          this.mainColors = this.updateList(this.mainColors, key, value);
          return;
        }
        this.componentsColors = this.updateList(this.componentsColors, key, value);
      },

      updateList(list, key, value) {
        return list.map(color => {
          if (color.key === key) {
            color.value = value;
          }
          return color;
        });
      },

      exportVariables() {
        const mainColors = this.mainColors.map(color => {
          return `${color.key}: ${color.value};`;
        });

        const componentsColors = this.componentsColors.map(color => {
          return `${color.key}: ${color.value};`;
        });

        const blob = new Blob([mainColors.join('\n')], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'microbrands-main-colors.txt';
        a.click();

        const blob2 = new Blob([componentsColors.join('\n')], { type: 'text/plain' });
        const url2 = URL.createObjectURL(blob2);

        const a2 = document.createElement('a');
        a2.href = url2;
        a2.download = 'microbrands-components-colors.txt';
        a2.click();

        URL.revokeObjectURL(url);
      },

      resetVaribles() {
        localStorage.removeItem('mainColors');
        localStorage.removeItem('componentsColors');
        location.reload();
      },

      removeVarFromString(str) {
        return str.replace('var(', '').replace(')', '');
      },

      getComponentsHex(value) {
        const variableName = this.removeVarFromString(value);
        let hex = '';
        this.mainColors.forEach(color => {
          if (color.key === variableName) {
            hex = color.value;
            return;
          }
        });
        return hex;
      },
    },
  };
</script>
